<template>
  <CFooter :fixed="false" class="footer-info-mobile">
    <div>
      <span class="ml-md-1 footer-info"
        >Copyright &copy; {{ new Date().getFullYear() }} Fabbi JSC. All rights
        reserved.
      </span>
    </div>
    <div class="ml-md-auto">
      <span class="mr-1 footer-info" />
    </div>
  </CFooter>
</template>

<script>
export default {
  name: "Footer"
};
</script>
<style lang="scss">
@media only screen and (max-device-width: 767px) {
  .c-footer.footer-info-mobile {
    padding-top: 10px;
  }
}
</style>
